<template>
    <transition name="component-fade">
        <section v-if="isActive" class="overlay tariffs-overlay">
            <div class="overlay__inner">
                <header class="overlay__header">
                    <h3 class="overlay__headline">
                        {{ $t(`overlays.${type}.headline`) }}
                    </h3>
                    <button class="icon-btn close-btn" @click="closeOverlay()">
                        <svg class="icon" width="16px" height="16px">
                            <use xlink:href="#icon-x" />
                        </svg>
                    </button>
                </header>
                <div class="overlay__content">
                    <div class="tariff-table">
                        <table>
                            <thead>
                                <tr>
                                    <th class="service-header">{{ $t('overlays.tariffs.text.table-headline') }}</th>
                                    <th v-for="product in services" :key="product.title" :class="product.icon">
                                        <img
                                            :src="`/hausbankstatus/assets/img/${product.icon}.svg`"
                                            alt="product.title"
                                        />
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(category, index) in serviceCategories"
                                    :key="category.name"
                                    :class="{ 'first-of-category': [0, 3, 5, 7, 11, 14].includes(index) }"
                                >
                                    <th width="50%" class="size-small" v-html="category.text" />
                                    <td
                                        v-for="(product, index) in services"
                                        :key="product.title"
                                        class="size-small"
                                        :class="{
                                            'check': service(index, category.name) === '✓',
                                            'komplett': index === 0,
                                            'individual': index === 1,
                                            'direkt': index === 2,
                                            'direkt-light': index === 3,
                                        }"
                                        width="12.5%"
                                    >
                                        {{ service(index, category.name) }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p class="small-text mt-1 mb-0 color-gray">
                        {{ $t('overlays.tariffs.text.notice') }}
                    </p>
                    <!--
                    <p class="small-text color-gray mt-1">
                        <small>{{ $t('overlays.tariffs.text.footnote-1') }}</small>
                        <br />
                        <small>{{ $t('overlays.tariffs.text.footnote-2') }}</small>
                        <br />
                        <small>{{ $t('overlays.tariffs.text.footnote-3') }}</small>
                        <br />
                        <small>{{ $t('overlays.tariffs.text.footnote-4') }}</small>
                    </p>
                    -->
                </div>
            </div>
        </section>
    </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import Helpers from '@/helpers';
export default {
    props: {
        type: {
            type: String,
            default: 'bankstatus',
        },
        isActive: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            serviceCategories: [
                // --- Buchungen
                { name: 'booking_1', text: 'Überweisung Online-Banking' },
                { name: 'booking_2', text: 'Gut-/Lastschrift und Durchführung Dauerauftrag' },
                { name: 'booking_3', text: 'Überweisung beleghaft / Scheckeinreichung' },
                // --- Bargeld Ein-/Auszahlung
                { name: 'cash_1', text: 'Am Geldautomaten mit der Debitkarte' },
                { name: 'cash_2', text: 'Am Schalter' },
                // --- Debitkarte
                { name: 'debit_card_1', text: 'Girocard' },
                { name: 'debit_card_2', text: 'Digitale Girocard' },
                // --- Kreditkarte
                { name: 'credit_card_1', text: 'GoldCard  inkl. 12 freier Bargeldverfügungen p.a.' },
                { name: 'credit_card_2', text: 'ClassicCard' },
                { name: 'credit_card_3', text: 'DirectCard' },
                { name: 'credit_card_4', text: 'BasicCard' },
                // --- Mehrwerte
                { name: 'service_1', text: 'Kontoauszug im elektronischen Postfach' },
                { name: 'service_2', text: 'Kontoauszug am Kontoauszugsdrucker' },
                { name: 'service_3', text: 'VR-SecureGo TAN' },
                // --- Kontoführung
                { name: 'status_1', text: 'Kontoführung p. M.' },
                { name: 'status_2', text: '<b>Kontoführung p. M. für Mitglieder</b> im Platin-Status' },
            ],
            services: [
                {
                    title: 'VR Komplett',
                    icon: 'komplett',
                    booking_1: true,
                    booking_2: true,
                    booking_3: true,
                    // ---
                    cash_1: true,
                    cash_2: true,
                    // ---
                    debit_card_1: 6,
                    debit_card_2: true,
                    // ---
                    credit_card_1: 90,
                    credit_card_2: 36,
                    credit_card_3: 36,
                    credit_card_4: 30,
                    // ---
                    service_1: true,
                    service_2: true,
                    service_3: true,
                    // ---
                    status_1: 9.9,
                    status_2: -6.1,
                },
                {
                    title: 'VR Individual',
                    icon: 'individual',
                    booking_1: 0.09,
                    booking_2: 0.49,
                    booking_3: 0.99,
                    // ---
                    cash_1: true,
                    cash_2: 0.99,
                    // ---
                    debit_card_1: 6,
                    debit_card_2: true,
                    // ---
                    credit_card_1: 90,
                    credit_card_2: 36,
                    credit_card_3: 36,
                    credit_card_4: 30,
                    // ---
                    service_1: true,
                    service_2: true,
                    service_3: 0.09,
                    // ---
                    status_1: 4.9,
                    status_2: -11.1,
                },
                {
                    title: 'VR Direkt',
                    icon: 'direkt',
                    booking_1: true,
                    booking_2: true,
                    booking_3: 2.49,
                    // ---
                    cash_1: true,
                    cash_2: 2.49,
                    // ---
                    debit_card_1: 6,
                    debit_card_2: true,
                    // ---
                    credit_card_1: 90,
                    credit_card_2: 36,
                    credit_card_3: 36,
                    credit_card_4: 30,
                    // ---
                    service_1: true,
                    service_2: 0.3,
                    service_3: true,
                    // ---
                    status_1: 5.9,
                    status_2: -10.1,
                },
                {
                    title: 'VR Direkt light',
                    icon: 'direkt-light',
                    booking_1: true,
                    booking_2: 0.12,
                    booking_3: 2.49,
                    // ---
                    cash_1: true,
                    cash_2: 2.49,
                    // ---
                    debit_card_1: 6,
                    debit_card_2: true,
                    // ---
                    credit_card_1: 90,
                    credit_card_2: 36,
                    credit_card_3: 36,
                    credit_card_4: 30,
                    // ---
                    service_1: true,
                    service_2: 0.3,
                    service_3: true,
                    // ---
                    status_1: 3.9,
                    status_2: -12.1,
                },
            ],
        };
    },
    computed: {
        ...mapGetters(['getAppModules']),
        service() {
            return (tariff, category) => {
                const content = this.services[tariff][category];

                if (typeof content === 'boolean') {
                    return content === true ? '✓' : 'x';
                }
                if (typeof content === 'number') {
                    return Helpers.formatNumberAsEuro(content);
                }
                if (typeof content === 'string') {
                    return content;
                }
            };
        },
    },
    methods: {
        closeOverlay() {
            this.$store.commit('UPDATE_VIEW', {
                view: `${this.type}Overlay`,
                payload: false,
            });
        },
        keyListeners: function(e) {
            // Listen to ESC key
            if (e.keyCode === 27) {
                this.closeOverlay();
            }
        },
    },
    watch: {
        isActive(newValue) {
            if (newValue === true) {
                document.addEventListener('keyup', this.keyListeners);
            } else {
                document.removeEventListener('keyup', this.keyListeners);
            }
        },
    },
};
</script>
